import retureButton from "./component/button.js";
import finishModule from "./component/finish";
import applyingModule from "./component/applying";
import orderPayModule from "./component/orderPay";
import retureTable from "./component/table";
import { getAvailableCompanyList } from "@/api/base";
import { getBoardTotalDataApi } from "@/api/retureBoard";
import "./styles/index.scss";
import moment from "moment";
export default {
  data() {
    return {
      companyId: "1",
      companyOptions: [{ id: "1", appName: "集团数据" }],
      timeTypeArr: ["订单支付时间", "申请退费时间", "完成退费时间"],
      timeType: 1, // 日期类型：1 订单支付时间，2 申请退费时间，3 完成退费时间
      timeRange: [moment().format("YYYY-MM-") + '01', moment().format("YYYY-MM-DD")], // 时间
      boardData: null, // 数据
      isAdmin: true,
    };
  },
  mounted() {
    if (this.$myStore.state.user) {
      this.isAdmin = this.$myStore.state.user.userInfo.companyId === "1";
    }
    this.getCompanyListMeth();
    this.getDaboardDataMeth();
  },
  methods: {
    getCompanyListMeth() {
      getAvailableCompanyList().then((result) => {
        this.companyOptions = this.companyOptions.concat(
          result.data.map((e) => {
            return {
              appName: e.appName,
              id: e.id,
            };
          })
        );
        this.companyOptions.push({ id: "100", appName: "中英考研" });
        this.companyOptions.push({ id: "300", appName: "师来考编" });
        this.companyOptions.push({ id: "400", appName: "神啦考研" });
      });
    },
    // 获取统计数据
    getDaboardDataMeth() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const _params = {
        belongCompanyId: this.companyId == 1 ? null : this.companyId,
        dateType: this.timeType,
      };
      if (this.timeRange) {
        _params.thatDateStart = this.timeRange[0] + " 00:00:00";
        _params.thatDateEnd = this.timeRange[1] + " 23:59:59";
      } else {
        _params.thatDateStart = null;
        _params.thatDateEnd = null;
      }
      getBoardTotalDataApi(_params)
        .then((result) => {
          loading.close();
          this.boardData = result.data;
        })
        .catch(() => {
          loading.close();
        });
      this.$nextTick(() => {
        this.$refs.myTable.init();
      });
    },
    timeTypeChangeMeth(v) {
      this.timeType = v;
      this.getDaboardDataMeth();
    },
  },
  render(h) {
    const {
      isAdmin,
      companyOptions,
      companyId,
      timeTypeArr,
      timeType,
      boardData,
    } = this;
    return h("div", [
      h("div", {}, [
        isAdmin &&
          companyOptions.map((element) => {
            return h(
              retureButton,
              {
                class: { ["active"]: companyId == element.id },
                on: {
                  onClick: () => {
                    this.companyId = element.id;
                    this.getDaboardDataMeth();
                  },
                },
              },
              element.appName
            );
          }),
        h("div", { class: ["filter"] }, [
          h(
            "el-form",
            { props: { size: "small", labelWidth: "80px", inline: true } },
            [
              h("el-form-item", { props: { label: "时间类型" } }, [
                h(
                  "el-select",
                  {
                    props: { value: this.timeType },
                    on: {
                      change: this.timeTypeChangeMeth,
                    },
                  },
                  timeTypeArr.map((e, i) => {
                    return h("el-option", {
                      props: { label: e, value: i + 1, key: i + 1 },
                    });
                  })
                ),
              ]),
              h(
                "el-form-item",
                { props: { data: this.timeRange, label: "时间筛选" } },
                [
                  h("el-date-picker", {
                    props: {
                      value: this.timeRange,
                      type: "daterange",
                      rangeSeparator: "至",
                      startPlaceholder: "开始日期",
                      endPlaceholder: "结束日期",
                      valueFormat: "yyyy-MM-dd",
                      clearable: false,
                    },
                    on: {
                      input: (v) => {
                        this.timeRange = v;
                      },
                      change: (v) => {
                        this.getDaboardDataMeth();
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
          h(
            retureButton,
            {
              class: ["active"],
              on: {
                onClick: () => this.getDaboardDataMeth(),
              },
            },
            "刷新"
          ),
        ]),
      ]),
      h("div", {}, [
        h(
          "div",
          {
            style: {
              paddingTop: "10px",
              width: "100%",
              overflow: "auto",
            },
          },
          [
            h(
              "div",
              {
                style: {
                  minWidth: "1300px",
                },
              },
              // "订单支付时间", "申请退费时间", "完成退费时间"
              [
                timeType === 1 &&
                  h(orderPayModule, {
                    props: {
                      boardData: boardData,
                    },
                  }),
                timeType === 2 &&
                  h(applyingModule, {
                    props: {
                      boardData: boardData,
                    },
                  }),
                timeType === 3 &&
                  h(finishModule, {
                    props: {
                      boardData: boardData,
                    },
                  }),
              ]
            ),
            isAdmin &&
              this.companyId == "1" &&
              h(retureTable, {
                ref: "myTable",
                props: {
                  companyArray: this.companyOptions,
                  companyId: this.companyId,
                  timeType: this.timeType,
                  timeRange: this.timeRange,
                },
                style: {
                  minWidth: "1300px",
                },
              }),
          ]
        ),
      ]),
    ]);
  },
};
